import { api, apiDelete, apiPost, apiPut } from "@/shared/api/http";

export interface KeyState {
  set: boolean;
  hint: string | null;
  valid: boolean;
}

export interface KeysOut {
  openai: KeyState;
  yandex: KeyState;
}

export type Provider = "openai" | "yandex";

export const fetchKeys = () => api<KeysOut>("/api/me/keys");

export const setKey = (provider: Provider, key: string) =>
  apiPut<KeyState>(`/api/me/keys/${provider}`, { key });

export const deleteKey = (provider: Provider) =>
  apiDelete<{ ok: boolean }>(`/api/me/keys/${provider}`);

export const validateKeys = () => apiPost<KeysOut>("/api/me/keys/validate", {});
